import React from "react";
import "./button.css";
import "./button_wait.css";
import "./button_success.css";
import "./button_wrong.css";
import './button_success_animation.css';

import wait from "../../assets/icons/oval.svg";
import success from "../../assets/icons/success.svg";
import wrong from "../../assets/icons/wrong.svg";

export class Button extends React.Component {
  render() {
    return (
      <div
        className={
          this.props.status === "wait"
            ? "button button_theme_wait"
            : this.props.status === "success"
            ? "button button_theme_success"
            : "button button_theme_wrong"
        }
        onClick={this.props.onClick}
      >
        <img alt="button-img"
          className="button__img"
          src={
            this.props.status === "wait"
              ? wait
              : this.props.status === "success"
              ? success
              : wrong
          }
        />
        <div
          className={
            this.props.status === "wait"
              ? "button__text button__text_theme_wait"
              : this.props.status === "success"
              ? "button__text button__text_theme_success"
              : "button__text button__text_theme_wrong"
          }
        >
          {this.props.text}
        </div>
      </div>
    );
  }
}
